import React, { Component } from "react";
import PropTypes from "prop-types";
import Lightbox from "react-image-lightbox";

// Style
import "react-image-lightbox/style.css";

class ImageGallery extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentIndex:
        this.props.currentIndex !== undefined ? this.props.currentIndex : 0,
    };
  }

  _onPrev = () => {
    const { images } = this.props;
    const { currentIndex } = this.state;
    this.setState({
      currentIndex: (currentIndex + images.length - 1) % images.length,
    });
  };

  _onNext = () => {
    const { images } = this.props;
    const { currentIndex } = this.state;

    this.setState({
      currentIndex: (currentIndex + 1) % images.length,
    });
  };

  render() {
    const { images } = this.props;
    const { currentIndex } = this.state;

    return (
      <Lightbox
        mainSrc={images[currentIndex].src}
        nextSrc={
          currentIndex !== images.length - 1
            ? images[(currentIndex + 1) % images.length].src
            : undefined
        }
        prevSrc={
          images.length !== 1
            ? currentIndex !== 0
              ? images[(currentIndex + images.length - 1) % images.length].src
              : undefined
            : undefined
        }
        onCloseRequest={this.props.onClose}
        onMovePrevRequest={this._onPrev}
        onMoveNextRequest={this._onNext}
        imageTitle={
          images[currentIndex].title !== undefined
            ? images[currentIndex].title
            : ""
        }
        imageCaption={
          images[currentIndex].caption !== undefined
            ? images[currentIndex].caption
            : ""
        }
        toolbarButtons={[
          <span>
            {currentIndex + 1}/{images.length}
          </span>,
        ]}
        reactModalStyle={this.props.modalStyle ? this.props.modalStyle : {}}
      />
    );
  }
}

ImageGallery.propTypes = {
  images: PropTypes.array.isRequired,
  currectIndex: PropTypes.number,
  // Function
  onClose: PropTypes.func.isRequired,
};

export default ImageGallery;
